module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-card"
  }, [(_vm.$slots.header || _vm.header) ? _c('div', {
    staticClass: "zk-card__header"
  }, [_vm._t("header", [_vm._v(_vm._s(_vm.header))])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "zk-card__body",
    style: (_vm.bodyStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "zk-card__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-e97fad82"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/card/src/card.vue
// module id = 284
// module chunks = 0